import React, { useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router';

import { FormContext } from '@glu/validation-react';

import Workflow from 'components/workflow/Workflow';
import Amount from 'components/sendPayment/Amount';
import LocaleContext from 'components/locale/LocaleContext';
import { WORKSPACES, TRANSFER_TABS, URL_PARAM_ACTIONS } from 'constants.js';

import RecurringTransferForm from './RecurringTransferForm';

const { RECURRING } = TRANSFER_TABS;
const { TRANSFER } = WORKSPACES;
const { VIEW } = URL_PARAM_ACTIONS;

const getTitle = (locale, action) => {
  switch (action) {
    case 'modify':
      return locale['common.modifyRecurringInstruction'];
    case 'view':
      return locale['common.viewRecurringInstruction'];
    case 'create':
    default:
      return locale['common.createRecurringInstruction'];
  }
};

export function RecurringTransferWorkflowComponent() {
  const history = useHistory();
  const locale = useContext(LocaleContext);
  const { data: values } = useContext(FormContext);
  const { action } = useParams();

  const [canceling, setCanceling] = useState(false);

  const returnToRecurringTab = () =>
    history.push({
      pathname: history?.location?.state?.previous || TRANSFER,
      state: {
        activeTab: RECURRING
      }
    });

  return (
    <Workflow
      extra={<Amount amount={values?.amount} />}
      onBack={() => {
        if (action === VIEW) {
          returnToRecurringTab();
        } else {
          setCanceling(true);
        }
      }}
      title={getTitle(locale, action)}
    >
      <RecurringTransferForm useCanceling={[canceling, setCanceling]} />
    </Workflow>
  );
}

export default RecurringTransferWorkflowComponent;
